import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import ForgotPassword from '../screens/ForgotPassword';
import Login from '../screens/Login';
import OtpLogin from '../screens/OtpLogin';
import PrivateRoutes from './PrivateRoutes';
import PublicRoute from './PublicRoute';
import ResetPassword from '../screens/ResetPassword';
import ServiceAgreements from '../screens/ServiceAgreements/ServiceAgreements';
import UserProfile from '../screens/Profile';
import AddFarm from '../screens/AddFarms-BillingEntity';
import LandlordDataTable from '../screens/LandlordMapping';
import LandlordShareBillComponent from '../components/PDF-Converter/LandlordBillGenerator';
import Pricing from '../screens/Pricing-costs/Pricing.tsx';
import { InventoryManagement } from '../screens/InventoryManagement/InventoryManagement.tsx';

const getPublicRoute = (Component: FC) => (
  <PublicRoute>
    <Component />
  </PublicRoute>
);
const getRoute = (Component: FC) => <Component />;
const AppRoutes = () => {

  return (
    <Routes>
      <Route element={getPublicRoute(Login)} path='/login' />
      <Route element={getPublicRoute(ForgotPassword)} path='/forgot-password' />
      <Route element={getPublicRoute(ResetPassword)} path='/reset-password' />
      <Route element={getPublicRoute(OtpLogin)} path='/otp-login' />
      <Route element={<PrivateRoutes />} path='/'>
      <Route element={getRoute(ServiceAgreements)} path='/' />
    </Route>
    <Route element={<PrivateRoutes />} path='/landlord-field-mapping' >
      <Route element={getRoute(LandlordDataTable)} path='/landlord-field-mapping'/>
    </Route>
    <Route element={<PrivateRoutes />} path='/landlord-bills' >
      <Route element={getRoute(LandlordShareBillComponent)} path='/landlord-bills'/>
    </Route>
    <Route element={<PrivateRoutes/>} path='/pricing-costs'>
      <Route element={getRoute(Pricing)} path='/pricing-costs'>
      </Route>
    </Route>
      <Route element={<PrivateRoutes />} path='/landlords'>
        <Route element={getRoute(ServiceAgreements)} path='/landlords' />
      </Route>
      <Route element={<PrivateRoutes />} path='/add-new-farm'>
        <Route element={getRoute(AddFarm)} path='/add-new-farm' />
      </Route>
      <Route element={<PrivateRoutes />} path='/inventory-management' >
      <Route element={getRoute(InventoryManagement)} path='/inventory-management'/>
    </Route>
      <Route element={<PrivateRoutes />} path='/user-profile'>
        <Route element={getRoute(UserProfile)} path='/user-profile' />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
